/* GKT gaming layout — carousels, category tabs, marquee pause. */
(function () {
  'use strict';

  var CENTER_EPSILON = 2;

  function gapOf(track) {
    var cs = window.getComputedStyle(track);
    return parseFloat(cs.columnGap || cs.gap) || 0;
  }

  function itemStep(items, track) {
    if (!items.length) return track.clientWidth;
    return items[0].getBoundingClientRect().width + gapOf(track);
  }

  function perView(items, track) {
    var step = itemStep(items, track);
    if (!step) return 1;
    return Math.max(1, Math.round(track.clientWidth / step));
  }

  function initCarousel(root) {
    var track = root.querySelector('[data-carousel-track]');
    if (!track) return;

    var items = Array.prototype.slice.call(track.querySelectorAll('[data-carousel-item]'));
    if (!items.length) return;

    var prev = root.querySelector('[data-carousel-prev]');
    var next = root.querySelector('[data-carousel-next]');
    var dotsWrap = root.querySelector('[data-carousel-dots]');
    var centerMode = root.hasAttribute('data-carousel-center');

    var pages = 1;
    var page = 0;

    function pageCount() {
      return Math.max(1, Math.ceil(items.length / perView(items, track)));
    }

    function maxScroll() {
      return track.scrollWidth - track.clientWidth;
    }

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      if (pages < 2) return;
      for (var i = 0; i < pages; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'g-dot';
        dot.setAttribute('aria-label', 'Go to slide group ' + (i + 1));
        dot.addEventListener('click', goTo.bind(null, i));
        dotsWrap.appendChild(dot);
      }
    }

    function syncDots() {
      if (!dotsWrap) return;
      var dots = dotsWrap.children;
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('is-active', i === page);
      }
    }

    function syncArrows() {
      var left = track.scrollLeft;
      var max = maxScroll();
      if (prev) prev.disabled = left <= CENTER_EPSILON;
      if (next) next.disabled = left >= max - CENTER_EPSILON;
    }

    function goTo(index) {
      page = Math.max(0, Math.min(index, pages - 1));
      track.scrollTo({ left: Math.min(page * track.clientWidth, maxScroll()), behavior: 'smooth' });
      syncDots();
    }

    /* Marks the item nearest the track's horizontal centre, which is what
       drives the enlarged middle card in the best-seller row. */
    function syncCenter() {
      if (!centerMode) return;
      var mid = track.scrollLeft + track.clientWidth / 2;
      var best = null;
      var bestDist = Infinity;
      items.forEach(function (item) {
        var itemMid = item.offsetLeft + item.offsetWidth / 2;
        var dist = Math.abs(itemMid - mid);
        if (dist < bestDist) {
          bestDist = dist;
          best = item;
        }
      });
      items.forEach(function (item) {
        item.classList.toggle('is-active', item === best);
      });
    }

    function onScroll() {
      page = track.clientWidth ? Math.round(track.scrollLeft / track.clientWidth) : 0;
      page = Math.max(0, Math.min(page, pages - 1));
      syncDots();
      syncArrows();
      syncCenter();
    }

    function measure() {
      pages = pageCount();
      buildDots();
      onScroll();
    }

    if (prev) prev.addEventListener('click', function () { goTo(page - 1); });
    if (next) next.addEventListener('click', function () { goTo(page + 1); });

    var scrollTimer = null;
    track.addEventListener('scroll', function () {
      if (scrollTimer) window.cancelAnimationFrame(scrollTimer);
      scrollTimer = window.requestAnimationFrame(onScroll);
    }, { passive: true });

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(measure, 150);
    });

    measure();
    /* Fonts and lazy images shift widths after first paint. */
    window.setTimeout(measure, 300);
  }

  function initCategoryTabs(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-cat-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-cat-panel]'));
    if (!tabs.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var key = tab.getAttribute('data-cat-tab');
        tabs.forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          var on = p.getAttribute('data-cat-panel') === key;
          p.hidden = !on;
          if (on) {
            var carousel = p.querySelector('[data-carousel]');
            /* A hidden track measures 0 wide, so re-measure on reveal. */
            if (carousel) window.dispatchEvent(new Event('resize'));
          }
        });
      });
    });
  }

  var MOBILE = '(max-width: 989px)';

  function initHeader(header) {
    var burger = header.querySelector('[data-g-burger]');
    var nav = header.querySelector('.g-nav');
    var backdrop = header.querySelector('[data-g-nav-backdrop]');
    var closeBtn = header.querySelector('[data-g-nav-close]');

    function setMenu(open) {
      if (!nav) return;
      nav.classList.toggle('is-open', open);
      if (backdrop) backdrop.classList.toggle('is-open', open);
      document.body.classList.toggle('g-nav-lock', open);
      if (burger) burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    if (burger && nav) {
      burger.addEventListener('click', function () { setMenu(!nav.classList.contains('is-open')); });
    }
    if (closeBtn) closeBtn.addEventListener('click', function () { setMenu(false); });
    if (backdrop) backdrop.addEventListener('click', function () { setMenu(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav && nav.classList.contains('is-open')) setMenu(false);
    });
    /* Close the drawer when a real link is tapped. */
    if (nav) {
      nav.querySelectorAll('.g-nav__link[href]').forEach(function (a) {
        a.addEventListener('click', function () {
          if (!a.parentElement.classList.contains('has-children')) setMenu(false);
        });
      });
    }

    /* On mobile the dropdowns can't rely on :hover, so the parent link
       toggles its submenu on first tap and navigates on the second. */
    header.querySelectorAll('.g-nav__item.has-children > .g-nav__link').forEach(function (link) {
      link.addEventListener('click', function (e) {
        if (!window.matchMedia(MOBILE).matches) return;
        var item = link.parentElement;
        if (!item.classList.contains('is-open')) {
          e.preventDefault();
          item.classList.add('is-open');
        }
      });
    });
  }

  /* The visible cart button mirrors #cart-icon-bubble, which Dawn's cart JS
     re-renders on every add/remove. */
  function initCart(header) {
    var link = header.querySelector('[data-g-cart]');
    var countEl = header.querySelector('[data-g-cart-count]');
    var totalEl = header.querySelector('[data-g-cart-total]');
    var bubble = document.getElementById('cart-icon-bubble');
    if (!link) return;

    link.addEventListener('click', function (e) {
      if (typeof window.gktOpenCart !== 'function') return;
      if (!document.querySelector('cart-drawer')) return;
      e.preventDefault();
      window.gktOpenCart();
    });

    if (!bubble || !countEl) return;

    function money(cents) {
      var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: currency,
        }).format(cents / 100);
      } catch (err) {
        return (cents / 100).toFixed(2);
      }
    }

    function refresh() {
      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          countEl.textContent = cart.item_count;
          if (totalEl) totalEl.textContent = money(cart.total_price);
        })
        .catch(function () { /* leave the server-rendered values in place */ });
    }

    new MutationObserver(refresh).observe(bubble, { childList: true, subtree: true });
  }

  function initAll(scope) {
    scope.querySelectorAll('[data-carousel]').forEach(initCarousel);
    scope.querySelectorAll('[data-cat-tabs]').forEach(initCategoryTabs);
    scope.querySelectorAll('[data-g-header]').forEach(function (header) {
      initHeader(header);
      initCart(header);
    });
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () { initAll(document); });

  /* Sections added in the theme editor need the same wiring. */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
